// Small helper to read the localized AJAX URL.
export function getAjaxUrl() {
    return (window.HAEGOZIYA && window.HAEGOZIYA.ajaxUrl) || '/wp-admin/admin-ajax.php';
}
